import { Link } from 'react-router-dom';

import routes from '@/shared/constants/routesPath';

import Button from '@/components/ui/button';

const Footer = () => {
  return (
    <footer className="border-t border-t-white/20 bg-white/5 py-4 backdrop-blur-lg md:py-5">
      <div className="flex max-w-[1360px] flex-col-reverse items-center gap-4 px-4 md:container md:flex-row md:justify-between md:gap-0">
        <div className="flex flex-row-reverse items-center md:flex-row">
          <p className="text-base opacity-40">
            &copy; {new Date().getFullYear()} Lanetalk
          </p>
          <div className="h-6 border-l border-white/20 mx-4"></div>
          <Button variant="link" asChild>
            <Link
              to={routes.SWEDISH_LEAGUE}
              target="_blank"
              rel="noopener noreferrer"
            >
              Swedish league
            </Link>
          </Button>
        </div>
        <div>
          <Link
            to={routes.TERMS}
            className="opacity-40 transition-opacity hover:opacity-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </Link>
          <span className="mx-2 opacity-40">/</span>
          <Link
            to={routes.PRIVACY}
            className="opacity-40 transition-opacity hover:opacity-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
